export { default, type AccordionItemProps } from './AccordionItem';
